// extracted by mini-css-extract-plugin
export default {"noBackground":"aga-z","qnaContainer":"bga-z","qna":"cga-z","question":"dga-z","modal":"ega-z"};